import GameSidebar from './game-sidebar';
import { SidebarProvider, SidebarTrigger } from './ui/sidebar';

import { Outlet, useParams } from 'react-router-dom';

const GameLayout = () => {
	const { projectId, gameId } = useParams<{
		projectId: string;
		gameId: string;
	}>();
	// const navigate = useNavigate();
	// const { data: user, isLoading, error } = useUser();

	// if (isLoading) {
	// 	return <div>Loading...</div>;
	// }

	// if (error) {
	// 	console.error(error);
	// 	navigate('/login');
	// }

	return (
		<SidebarProvider>
			<GameSidebar
				projectId={Number(projectId)}
				gameId={gameId?.length ? Number(gameId) : undefined}
			/>
			<main className="flex-1">
				<SidebarTrigger />
				<div className="py-6">
					<Outlet />
				</div>
			</main>
		</SidebarProvider>
	);
};

export default GameLayout;
